/* eslint-disable @angular-eslint/component-selector */

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'puck_line-icon',
  template: `<span
    class="puck-icon puck-icon--line"
    [style.background-image]="backgroundImage()"
    aria-hidden="true"
  ></span>`,
  styleUrl: './puck-icon.component.scss',
})
export class PuckLineComponent {
  readonly backgroundImage = input<string | null>(null);
}

@Component({
  selector: 'puck_fill-icon',
  template: `<span
    class="puck-icon puck-icon--fill"
    [style.background-image]="backgroundImage()"
    aria-hidden="true"
  ></span>`,
  styleUrl: './puck-icon.component.scss',
})
export class PuckFillComponent {
  readonly backgroundImage = input<string | null>(null);
}

@Component({
  selector: 'app-puck-counter',
  standalone: true,
  templateUrl: './puck-counter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PuckLineComponent, PuckFillComponent],
})
export class PuckCounterComponent {
  readonly count = input.required<number>();
  readonly total = input(5);
  readonly lineBackgroundImage = input<string | null>(null);
  readonly fillBackgroundImage = input<string | null>(null);

  readonly items = computed(() => Array.from({ length: this.total() }, (_, i) => i));
}
